import { useState, useEffect,  } from 'react';
  import { useDispatch, useSelector } from 'react-redux';
  import { useNavigate } from 'react-router-dom';
  import { toast } from 'react-toastify';
  import { 
    inviteMember, 
    acceptInvitationThunk, 
    removeInvitationThunk,
    removeMemberThunk,
    fetchGroupData,
    fetchUserInvitations,
    rejectInvitationThunk,
    createKidAccount,
    updateMember
  } from '../../../../app/store/slices/groupSlice';
  import { fetchUserData, selectUser } from '../../../../app/store/slices/userSlice';
  import {
    fetchUserCanvases,
    selectCanvases,
    fetchCanvasById,
  } from '../../../../app/store/slices/canvasSlice';
  import { FaEye, FaEyeSlash } from 'react-icons/fa';
  import {fetchSubscriptionData, selectCurrentPlan } from '../../../../app/store/slices/subscriptionSlice';
  import SubscriptionSwitchModal from '../SubscriptionSwitchModal'; 
  import { verifyInvitationThunk } from '../../../../app/store/slices/groupSlice';
  import DataStatusMessage from '../../../shared/components/modals/DataStatusMessage';


  const ManageGroupContent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showInviteForm, setShowInviteForm] = useState(false);
    const [inviteData, setInviteData] = useState({
      email: '',
      role: 'member',
      canvasId: '',
    });
    const [showKidForm, setShowKidForm] = useState(false);
    const [kidData, setKidData] = useState({
      name: '',
      email: '',
      canvasId: '',
      status:'',
      password: ''  
    });
    const [passwordStrength, setPasswordStrength] = useState('Weak');
    const [showKidPassword, setShowKidPassword] = useState(false);

    // Add new loading states at the top with other states
    const [isInviting, setIsInviting] = useState(false);
    const [isAddingKid, setIsAddingKid] = useState(false);
    const [isAccepting, setIsAccepting] = useState({});
    const [isRejecting, setIsRejecting] = useState({});

    // Add new state for edit forms
    const [showEditAdultForm, setShowEditAdultForm] = useState(false);
    const [showEditKidForm, setShowEditKidForm] = useState(false);
    const [editingMember, setEditingMember] = useState(null);
    const [editData, setEditData] = useState({
      role: '',
      canvasId: '',
      name: '',
      email: '',
      password: ''
    });

    const [isEditing, setIsEditing] = useState(false);
    const [isRemoving, setIsRemoving] = useState({});
    const [activeTab, setActiveTab] = useState('Adults');
    const { owned: ownedCanvases,  shared:sharedCanvases} = useSelector(selectCanvases) || { owned: [] };
    const { currentUser: user } = useSelector(state => state.user);
    const { members, invites, receivedInvites = [], } = useSelector(state => state.group);
    const userEmail = useSelector(state => state.auth.user?.email);
    const currentPlan = useSelector(selectCurrentPlan);
    const currentUser = useSelector(selectUser)
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [isDataError, setIsDataError] = useState(null);

    const PLAN_ORDER = ['free', 'trial', 'single', 'duo', 'family'];
    const getPlanIndex = (planKey) => PLAN_ORDER.indexOf((planKey || '').toLowerCase());

    const [showSwitchModal, setShowSwitchModal] = useState(false);
    const [invitedPlan, setInvitedPlan] = useState(null);
    const [pendingToken, setPendingToken] = useState(null);
    const [pendingInviteId, setPendingInviteId] = useState(null);
    const [memberCanvases, setMemberCanvases] = useState({});

    const isOwner = currentPlan?.owner===currentUser?._id;
    const isManager = Array.isArray(members) && members.some(
        m =>
          m.email?.toLowerCase() === currentUser?.email?.toLowerCase() &&
          m.role === 'manager'
    );


    useEffect(() => {
      const loadInitialData = async () => {
        setIsDataLoading(true);
        try {
          // Load all required data in parallel
          await Promise.all([
            dispatch(fetchUserData()),
            dispatch(fetchUserCanvases()),
            dispatch(fetchUserInvitations()),
            dispatch(fetchGroupData()),
          ]);
        } catch (error) {
          console.error('Failed to load data:', error);
          setIsDataError(error.message || 'Failed to load data');
        } finally {
          setIsDataLoading(false);
        }
      };

      loadInitialData();
    }, [dispatch]);

  useEffect(() => {
  const loadCanvasNames = async () => {
    const newCanvasMap = {};

    for (const inv of invites || []) {
      const id = inv.canvasId;
      if (!id || newCanvasMap[id]) continue;

      try {
        const canvas = await dispatch(fetchCanvasById(id)).unwrap();
        newCanvasMap[id] = canvas;
      } catch (err) {
        console.error('Error fetching canvas:', err);
        newCanvasMap[id] = { name: '-' };
      }
    }

    setMemberCanvases(newCanvasMap);
  };

  loadCanvasNames();
}, [invites]);


    const isDataValid = () => {
    return (
      user &&
      Array.isArray(ownedCanvases) &&
      Array.isArray(members) &&
      Array.isArray(invites) &&
      Array.isArray(receivedInvites)
      // currentPlan?.plan
    );
    };

    if (isDataLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px]">
        <div className="relative">
          <div className="h-12 w-12 rounded-full border-t-2 border-b-2 border-blue-600 animate-spin"></div>
        </div>
        <p className="mt-4 text-gray-600">Loading data...</p>
      </div>
    );
    }

    if (isDataError) {
    return (
      <DataStatusMessage
        type="error"
        message={isDataError}
        buttonText="Retry Loading"
        onButtonClick={() => window.location.reload()}
      />
      )};

    if (!isDataValid()) {
    return (
      <DataStatusMessage
        type="refresh"
        message="Unable to load canvas data. Please try again."
        buttonText="Refresh Page"
        onButtonClick={() => window.location.reload()}
      />
    )};
    const handleInvite = async (e) => {
      e.preventDefault();


      // Check for self-invitation
      if (inviteData.email.toLowerCase() === user?.email.toLowerCase()) {
        toast.error("You cannot invite yourself");
        return;
      }

      // Check plan restrictions
      if (!canAddAdults()) {
        toast.error(getAdultInviteMessage());
        return;
      }

      // Check if email is already invited
      const isAlreadyInvited = invites?.some(
        inv => inv.email.toLowerCase() === inviteData.email.toLowerCase()
      );

      if (isAlreadyInvited) {
        toast.error('This email has already been invited');
        return;
      }

      setIsInviting(true);
      try {
        await dispatch(inviteMember(inviteData)).unwrap();
        setShowInviteForm(false);
        await Promise.all([
          dispatch(fetchGroupData()),
          dispatch(fetchUserInvitations())
        ]);
        toast.success('Invitation sent successfully!');
        setInviteData({ email: '', role: 'member', canvasId: '' });
      } catch (error) {
        toast.error(error.message || 'Failed to send invitation');
        console.error('Failed to invite member:', error);
      } finally {
        setIsInviting(false);
      }
    };

  const handleAcceptInvite = async (token, inviteId) => {
    setIsAccepting(prev => ({ ...prev, [inviteId]: true }));
    try {
      //verify the invite
      const verifyResult = await dispatch(verifyInvitationThunk(token)).unwrap();

      const invitationPlanKey = verifyResult?.data?.planKey;
      const invitationPlanName = verifyResult?.data?.planName || invitationPlanKey;

      // Compare plans
      const invitedIndex = getPlanIndex(invitationPlanKey);
      const currentIndex = getPlanIndex(currentPlan?.plan?.planKey);


      if (currentPlan && currentPlan?.status === 'active') {
        if (invitedIndex > currentIndex) {
          // Show modal to switch/upgrade
          setInvitedPlan({ planKey: invitationPlanKey, name: invitationPlanName });
          setPendingToken(token);
          setPendingInviteId(inviteId);
          setShowSwitchModal(true);
          setIsAccepting(prev => ({ ...prev, [inviteId]: false }));
          return;
        } else {
          toast.error('You have already an Active Subscription');
          setIsAccepting(prev => ({ ...prev, [inviteId]: false }));
          return;
        }
      }

      // No active plan, just accept
      let result = await dispatch(acceptInvitationThunk(token)).unwrap();

      if (result?.status === 'already_member') {
        setInvitedPlan({ planKey: invitationPlanKey, name: invitationPlanName });
        setPendingToken(token);
        setPendingInviteId(inviteId);
        setShowSwitchModal(true);
        setIsAccepting(prev => ({ ...prev, [inviteId]: false }));
        toast.info(result.message || 'You are already a member of a subscription.');
        return;
      }

      // Success
      await Promise.all([
        dispatch(fetchGroupData()),
        dispatch(fetchUserInvitations())
      ]);
      toast.success('Invitation accepted successfully');
    } catch (error) {
      toast.error(error || 'Failed to accept invitation');
      console.error('Accept invite failed', error);
    } finally {
      setIsAccepting(prev => ({ ...prev, [inviteId]: false }));
    }
  };

  const handleSwitchConfirm = async () => {
  setShowSwitchModal(false);
  setIsAccepting(prev => ({ ...prev, [pendingInviteId]: true }));
  try {
    await dispatch(acceptInvitationThunk({ token: pendingToken, forceSwitch: true })).unwrap();
    await Promise.all([
      dispatch(fetchGroupData()),
      dispatch(fetchUserInvitations()),
      dispatch(fetchSubscriptionData()),
      dispatch(fetchUserCanvases()),
    ]);
    toast.success('Invitation accepted and plan switched!');
  } catch (error) {
    toast.error(error || 'Failed to accept invitation');
  } finally {
    setIsAccepting(prev => ({ ...prev, [pendingInviteId]: false }));
    setPendingToken(null);
    setPendingInviteId(null);
    setInvitedPlan(null);
  }
  };

  const handleSwitchCancel = () => {
    setShowSwitchModal(false);
    setPendingToken(null);
    setPendingInviteId(null);
    setInvitedPlan(null);
    toast.info('Stayed with your current subscription.');
  };
  
  // Update handleRemoveInvite function
  const handleRemoveInvite = async (memberEmail, isInvite = true) => {
    setIsRemoving(prev => ({ ...prev, [memberEmail]: true }));
    try {
      if (isInvite) {
        await dispatch(removeInvitationThunk(memberEmail)).unwrap();
        toast.success('Invitation removed successfully');
      } else {
        // Find the member's canvas ID before removing
        if(invites===null || invites.length===0){
          throw new Error('No invites found');
        }
        const member = invites.find(inv => inv.email === memberEmail);
        if (!member) {
          throw new Error('Member not found');
        }

        await dispatch(removeMemberThunk({ 
          memberEmail, 
          canvasId: member.canvasId 
        })).unwrap();
        toast.success('Member removed successfully');
      }
    await Promise.all([
        dispatch(fetchGroupData()),
        dispatch(fetchUserInvitations()),
        dispatch(fetchUserCanvases()),
        dispatch(fetchSubscriptionData())
      ]);
    } catch (error) {
      toast.error(error.message || 'Failed to remove member');
      console.error('Remove failed:', error.response?.data?.message || error.message);
    } finally {
      setIsRemoving(prev => ({ ...prev, [memberEmail]: false }));
    }
  };

  // Update the handleRejectInvite function
  const handleRejectInvite = async (invitationId) => {
    setIsRejecting(prev => ({ ...prev, [invitationId]: true }));
    try {
      if (!invitationId) {
        throw new Error('Invalid invitation data');
      }
      
      await dispatch(rejectInvitationThunk(invitationId)).unwrap();


      toast.success('Invitation rejected successfully');
      await Promise.all([
        dispatch(fetchGroupData()),
        dispatch(fetchUserInvitations())
      ]);
    } catch (error) {
      toast.error(error.message || 'Failed to reject invitation');
      console.error('Reject error:', error);
    } finally {
      setIsRejecting(prev => ({ ...prev, [invitationId]: false }));
    }
  };

  // Add password validation function
  const validatePassword = (password) => {
    const hasUpperCase = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[\W_]/.test(password);
    const hasMinLength = password.length >= 8;

    if (hasUpperCase && hasNumber && hasSpecialChar && hasMinLength) {
      setPasswordStrength('Strong');
    } else {
      setPasswordStrength('Weak');
    }
  };

    // Update the canAddKids function to handle all plan types
  const canAddKids = () => {
    if (!currentPlan || !currentPlan.plan) return false;
    const planKey = currentPlan.plan.planKey.toLowerCase();
    return planKey === 'family' || planKey==='trial'; // Only allow Family plan and trial to add kids
  };

  // Add a function to get plan-specific messages
  const getPlanMessage = () => {
    if (!currentPlan || !currentPlan.plan) return 'Please subscribe to a plan to add kids';
    const planKey = currentPlan.plan.planKey.toLowerCase();
    
    switch (planKey) {
      case 'free':
        return 'Upgrade to Family Premium plan to add kids';
      case 'single':
        return 'Single plan does not support adding kids. Upgrade to Family Premium';
      case 'duo':
        return 'Duo plan does not support adding kids. Upgrade to Family Premium';
      default:
        return 'Please upgrade to Family Premium plan to add kids';
    }
  }; 


  // Helper to get all adult emails from members (subscription)
  const memberAdultEmails = Array.isArray(currentPlan?.members)
  ? currentPlan.members
      .filter(m => ['member', 'admin', 'manager'].includes(m.role))
      .map(m => m.email?.toLowerCase())
  : [];

  // Helper to get all adult emails from invites (pending/accepted)
  const inviteAdultEmails = Array.isArray(invites)
  ? invites
      .filter(inv => 
        ['member', 'admin', 'manager'].includes(inv.role) &&
        (inv.status === 'Accepted' || inv.status === 'Pending')
      )
      .map(inv => inv.email?.toLowerCase())
  : [];

  // Combine and count unique emails (avoid double-counting)
  const allAdultEmails = Array.from(new Set([...memberAdultEmails, ...inviteAdultEmails]));
  const adultCount = allAdultEmails.length;

  const canAddAdults = () => {
    if (!currentPlan || !currentPlan.plan) return false;
    const planKey = currentPlan.plan.planKey.toLowerCase();

    switch (planKey) {
      case 'free':
        return false;
      case 'single':
        return false;
      case 'duo':
        return adultCount < 2; // Allow only 1 additional member
      case 'family':
      case 'trial':
        return adultCount < 4; // Allow up to 3 additional members (total 4)
      default:
        return false;
    }
  };

  const getAdultInviteMessage = () => {
    if (!currentPlan || !currentPlan.plan) return 'Please subscribe to a plan to add members';
    const planKey = currentPlan.plan.planKey.toLowerCase();

    switch (planKey) {
      case 'free':
        return 'Upgrade to Premium or higher plan to add members';
      case 'single':
        return 'Single plan does not support adding members. Upgrade to Duo or Family plan';
      case 'duo':
        return adultCount >= 1
          ? 'You have reached the maximum members limit. Upgrade to Family plan to add more'
          : '';
      case 'family':
      case 'trial':
        return adultCount >= 3
          ? 'You have reached the maximum members limit'
          : '';
      default:
        return 'Please upgrade your plan to add members';
    }
  };

    // Add handler for creating kid account
    const handleCreateKid = async (e) => {
      e.preventDefault();
      
      if (!canAddKids()) {
        toast.error(getPlanMessage());
        return;
      }
    
      setIsAddingKid(true);
      try {
        if(!canAddKids()){
          toast.error('Please Upgrade to Family Plan To add kids')
          return
        }
        setIsAddingKid(true)
        if (!kidData.name) {
          throw new Error("Kid's name is required");
        }

        if (passwordStrength !== 'Strong') {
          throw new Error("Please provide a strong password");
        }

        await dispatch(createKidAccount(kidData)).unwrap();
        setShowKidForm(false);
        toast.success('Kid account created successfully!');
        setKidData({ name: '', email: '', status:'', canvasId: '', password: '' });
        dispatch(fetchGroupData());
      } catch (error) {
        const errorMessage = error || 'Failed to create kid account';
        if (errorMessage.includes('Maximum number of kids')) {
          toast.error('You have reached the maximum number of kids allowed in your plan. Please upgrade to add more.');
        } else {
          toast.error(errorMessage);
        }
        console.error('Create kid failed:', error);
      } finally {
        setIsAddingKid(false);
      }
    };

    const handleEditKid = async (kid) => {
      setEditingMember(kid);
      setEditData({
        name: kid.name,
        canvasId: kid.canvasId,
        password: '',
        userId: kid.userId
      });
      setShowEditKidForm(true);
    };

  const handleRemoveKid = async (kidEmail) => {
    setIsRemoving(prev => ({ ...prev, [kidEmail]: true }));
    try {
      // Find the kid's canvas ID before removing
      if( !members || members.length === 0 || members === null){
        throw new Error('No members found');
      }
      const kid = members?.find(member => 
        member.email === kidEmail && member.role === 'kid'
      );
      if (!kid) {
        throw new Error('Kid account not found');
      }

      await dispatch(removeMemberThunk({ 
        memberEmail: kidEmail, 
        canvasId: kid.canvasId 
      })).unwrap();
      
      toast.success('Kid account removed successfully');
      await Promise.all([
        dispatch(fetchGroupData()),
        dispatch(fetchUserCanvases()),
        dispatch(fetchSubscriptionData())
      ]);
    } catch (error) {
      toast.error(error.message || 'Failed to remove kid account');
      console.error('Remove kid failed:', error);
    } finally {
      setIsRemoving(prev => ({ ...prev, [kidEmail]: false }));
    }
  };

    // Add edit handler for adults
    const handleEditAdult = async (member) => {
      setEditingMember(member);
      setEditData({
        role: member.role,
        canvasId: member.canvasId,
        userId: member.userId,
      });
      setShowEditAdultForm(true);
    };

    // Add save handler for both adult and kid updates
    const handleSaveEdit = async (e) => {
      e.preventDefault();
      setIsEditing(true);
      
      try {
        const updateDto = editingMember.role === 'kid' 
          ? {
              name: editData.name,
              canvasId: editData.canvasId,
              userId: editData.userId,
              ...(editData.password && { password: editData.password })
            }
          : {
              role: editData.role,
              canvasId: editData.canvasId,
              userId: editData.userId,
            };

        await dispatch(updateMember({
          email: editingMember.email,
          updateDto
        })).unwrap();

        toast.success('Member updated successfully');
        setShowEditAdultForm(false);
        setShowEditKidForm(false);
        setEditingMember(null);
        dispatch(fetchGroupData());
      } catch (error) {
        toast.error(error.message || 'Failed to update member');
        console.error('Update failed:', error);
      } finally {
        setIsEditing(false);
      }
    };

    // Add the edit forms JSX
    const renderEditAdultForm = () => (
      <form onSubmit={handleSaveEdit} className="mb-4 p-4 bg-gray-50 rounded-lg w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="w-full">
            <select
              value={editData.role}
              onChange={e => setEditData({ ...editData, role: e.target.value })}
              className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent"
              required
            >
              <option value="member">Member</option>
              <option value="manager">Manager</option>
            </select>
          </div>
          <div className="w-full">
            <select
              value={editData.canvasId}
              onChange={e => setEditData({ ...editData, canvasId: e.target.value })}
              className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent"
              required
            >
              <option value="">Select Canvas</option>
              {Array.isArray(ownedCanvases) && ownedCanvases.map(canvas => (
                <option key={canvas._id} value={canvas._id}>{canvas.name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="mt-4 flex flex-col-reverse sm:flex-row justify-end gap-2">
          <button
            type="button"
            onClick={() => setShowEditAdultForm(false)}
            className="w-full sm:w-auto px-4 py-1.5 border rounded-lg text-sm hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isEditing}
            className="w-full sm:w-auto add-btn-settings disabled:opacity-75"
          >
            {isEditing ? (
              <span className="flex items-center gap-2">
                <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                </svg>
                Saving...
              </span>
            ) : (
              'Save Changes'
            )}
          </button>
        </div>
      </form>
    );

    const renderEditKidForm = () => (
      <form onSubmit={handleSaveEdit} className="mb-4 p-4 bg-gray-50 rounded-lg w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="w-full">
            <input
              type="text"
              placeholder="Kid's name"
              value={editData.name}
              onChange={e => setEditData({ ...editData, name: e.target.value })}
              className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent"
              required
            />
          </div>
          <div className="w-full">
            <select
              value={editData.canvasId}
              onChange={e => setEditData({ ...editData, canvasId: e.target.value })}
              className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent"
              required
            >
              <option value="">Select Canvas</option>
              {Array.isArray(ownedCanvases) && ownedCanvases.map(canvas => (
                <option key={canvas._id} value={canvas._id}>{canvas.name}</option>
              ))}
            </select>
          </div>
          <div className="w-full relative col-span-full md:col-span-2">
            <input
              type={showKidPassword ? 'text' : 'password'}
              placeholder="Password"
              value={editData.password}
              onChange={e => {
                setEditData({ ...editData, password: e.target.value });
                if (e.target.value) validatePassword(e.target.value);
              }}
              className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent pr-10"
              required
            />
            <button
              type="button"
              onClick={() => setShowKidPassword(!showKidPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
            >
              {showKidPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

      {/* Password strength indicator */}
      {editData.password && passwordStrength !== 'Strong' && (
        <div className="mt-3 p-3 bg-white rounded-lg border border-gray-200">
          <div className="space-y-2">
            <p className="text-sm font-medium text-gray-700">Password must contain:</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
              <span className={!(/[A-Z]/.test(kidData.password)) ? 'text-red-500' : 'text-green-500'}>
                {!(/[A-Z]/.test(kidData.password)) ? '✗' : '✓'} One Uppercase Letter
              </span>
              <span className="text-gray-400">•</span>
              <span className={!(/\d/.test(kidData.password)) ? 'text-red-500' : 'text-green-500'}>
                {!(/\d/.test(kidData.password)) ? '✗' : '✓'} One Number
              </span>
              <span className="text-gray-400">•</span>
              <span className={!(/[\W_]/.test(kidData.password)) ? 'text-red-500' : 'text-green-500'}>
                {!(/[\W_]/.test(kidData.password)) ? '✗' : '✓'} One Special Character
              </span>
              <span className="text-gray-400">•</span>
              <span className={kidData.password.length < 8 ? 'text-red-500' : 'text-green-500'}>
                {kidData.password.length < 8 ? '✗' : '✓'} Minimum 8+ Characters
              </span>
            </div>
          </div>
        </div>
      )}

      <div className="mt-4 flex flex-col-reverse sm:flex-row justify-end gap-2">
        <button
          type="button"
          onClick={() => setShowEditKidForm(false)}
          className="w-full sm:w-auto px-4 py-1.5 border rounded-lg text-sm hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isEditing || (editData.password && passwordStrength !== 'Strong')}
          className="w-full sm:w-auto add-btn-settings disabled:opacity-75"
        >
          {isEditing ? (
            <span className="flex items-center gap-2">
              <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
              </svg>
              Saving...
            </span>
          ) : (
            'Save Changes'
          )}
        </button>
      </div>
    </form>
    );

    // Add at the beginning of your return statement
    if (currentUser?.role === 'kid') {
      return (
        <div className="space-y-6">
          <h3 className="text-lg font-semibold text-[#0a363c]">My Details</h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-100">
                  <th className="text-left py-3 px-4">Name</th>
                  <th className="text-left py-3 px-4">Email</th>
                  <th className="text-left py-3 px-4">Shared Canvas</th>
                  <th className="text-left py-3 px-4">Status</th>
                </tr>
              </thead>
              <tbody className="text-sm">
                <tr className="border-b">
                  <td className="py-3 px-4 text-gray-700">{currentUser.name}</td>
                  <td className="py-3 px-4">{currentUser.email}</td>
                  <td className="py-3 px-4">
                    
                    {ownedCanvases.find(canvas => canvas._id === currentUser.canvasId)?.name || '-'}
                  </td>
                  <td className="py-3 px-4">
                    <span className="px-2 py-1 rounded-full text-sm bg-green-100 text-green-800">
                      Active
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    return (
      <div className="space-y-6">
        <SubscriptionSwitchModal
          open={showSwitchModal}
          currentPlan={currentPlan}
          invitedPlan={invitedPlan}
          onConfirm={handleSwitchConfirm}
          onCancel={handleSwitchCancel}
        />
        <div className="flex border-b">
          <button
            className={`px-4 py-2 text-lg font-medium ${
              activeTab === 'Adults'
                ? 'border-b-2 border-btn-primary text-btn-primary'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('Adults')}
          >
            Adults
          </button>
          <button
            className={`px-4 py-2 text-lg font-medium ${
              activeTab === 'Kids'
                ? 'border-b-2 border-btn-primary text-btn-primary'
                : 'text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('Kids')}
          >
            Kids
          </button>
        </div>

        {activeTab === 'Adults' ? (
          <div className="space-y-8">
            <div>
              <div className="flex justify-between items-center mb-4">
                <h3 className="font-semibold text-[#0a363c]">Adults</h3>
                <button
                  onClick={() => {
                    if (!canAddAdults()) {
                      toast.error(getAdultInviteMessage());
                      return;
                    }
                    setShowInviteForm(true);
                  }}
                  className={`add-btn-settings ${
                    canAddAdults() 
                      ? 'bg-btn-primary text-white hover:opacity-90' 
                      : 'bg-gray-200 text-gray-600 cursor-not-allowed'
                  }`}
                  disabled={!(isManager || isOwner)}
                >
                  Add User
                </button>
              </div>

              {/* Add warning banner for plan restrictions */}
              {!canAddAdults() && (
                <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                  <div className="flex items-center justify-between">
                    <p className="text-sm text-yellow-700">
                      {getAdultInviteMessage()}
                    </p>
                    {!(
                        !isOwner ||
                        (
                          currentPlan?.plan?.planKey?.toLowerCase() === 'family' &&
                          getAdultInviteMessage().includes('You have reached the maximum members limit')
                        )
                      ) && (
                        <button
                          onClick={() => navigate('/user-subscription')}
                          className="px-4 py-1.5 bg-btn-primary text-white text-sm rounded-lg hover:opacity-90"
                        >
                          Upgrade Plan
                        </button>
                      )}
                  </div>
                </div>
              )}

              {showInviteForm && (
                <form onSubmit={handleInvite} className="mb-4 p-4 bg-gray-50 rounded-lg w-full">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="w-full">
                      <input
                        type="email"
                        placeholder="Email address"
                        value={inviteData.email}
                        onChange={e => setInviteData({ ...inviteData, email: e.target.value })}
                        className={`w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent ${
                          inviteData.email.toLowerCase() === user?.email.toLowerCase() 
                            ? 'border-red-300 bg-red-50' 
                            : ''
                        }`}
                        required
                      />
                    </div>
                    <div className="w-full">
                      <select
                        value={inviteData.role}
                        onChange={e => setInviteData({ ...inviteData, role: e.target.value })}
                        className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent"
                        required
                      >
                        <option value="member">Member</option>
                        <option value="manager">Manager</option>
                      </select>
                    </div>
                    <div className="w-full">
                      <select
                        value={inviteData.canvasId}
                        onChange={e => setInviteData({ ...inviteData, canvasId: e.target.value })}
                        className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent"
                        required
                      >
                        <option value="">Select Canvas</option>
                        {Array.isArray(ownedCanvases) && ownedCanvases.map(canvas => (
                          <option key={canvas._id} value={canvas._id}>{canvas.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="mt-4 flex flex-col-reverse sm:flex-row justify-end gap-2">
                    <button
                      type="button"
                      onClick={() => setShowInviteForm(false)}
                      className="w-full sm:w-auto px-4 py-1.5 border rounded-lg text-sm hover:bg-gray-100"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isInviting || inviteData.email.toLowerCase() === user?.email.toLowerCase()}
                      className="w-full sm:w-auto add-btn-settings disabled:opacity-75"
                    >
                      {isInviting ? (
                        <span className="flex items-center gap-2">
                          <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                            <circle 
                              className="opacity-25" 
                              cx="12" 
                              cy="12" 
                              r="10" 
                              stroke="currentColor" 
                              strokeWidth="4"
                            />
                            <path 
                              className="opacity-75" 
                              fill="currentColor" 
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                          </svg>
                          Inviting...
                        </span>
                      ) : inviteData.email.toLowerCase() === user?.email.toLowerCase() ? (
                        'Cannot invite yourself'
                      ) : (
                        'Invite'
                      )}
                    </button>
                  </div>
                  {inviteData.email.toLowerCase() === user?.email.toLowerCase() && (
                    <p className="text-sm text-red-500 mt-2">
                      You cannot invite yourself
                    </p>
                  )}
                </form>
              )}

              {showEditAdultForm && renderEditAdultForm()}

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="text-left py-3 px-4">Member Email</th>
                      <th className="text-left py-3 px-4">Role</th>
                      <th className="text-left py-3 px-4">Shared Canvas</th>
                      <th className="text-left py-3 px-4">Status</th>
                      <th className="text-left py-3 px-4">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="text-sm">
                  {/* Owner */}
                    {members?.filter(m => m.isOwner).map(owner => (
                      <tr key={owner._id} className="border-b">
                        <td className="py-3 px-4 text-gray-700">{owner.email}</td>
                        <td className="py-3 px-4">Owner</td>
                        <td className="py-3 px-4">All</td>
                        <td className="py-3 px-4">
                          <span className="px-2 py-1 rounded-full text-sm bg-green-100 text-green-800">
                            Active
                          </span>
                        </td>
                        <td className="py-3 px-4">-</td>
                      </tr>
                      ))}

                    {/* Invited Users */}
                    {invites?.filter(inv => {
                      const ownerEmails = members
                      ?.filter(m => m.isOwner)
                      .map(m => m.email?.toLowerCase());
                    // Exclude if invite email matches any owner email (case-insensitive)
                    return !ownerEmails?.includes(inv.email?.toLowerCase());
                    }
                    ).map(inv => (
                     
                      <tr key={inv._id} className="border-b">
                        <td className="py-3 px-4 text-gray-700">{inv.email}</td>
                        <td className="py-3 px-4">{inv.role === 'manager' ? 'Manager' : 'Member'}</td>
                        <td className="py-3 px-4">
                          
                          {[...(ownedCanvases || []), ...(sharedCanvases || [])].find(canvas => canvas._id === inv.canvasId)?.name || memberCanvases[inv.canvasId]?.name}
                        </td>
                        <td className="py-3 px-4">
                          <span className={`px-2 py-1 rounded-full text-sm ${
                            inv.status === 'Accepted'
                              ? 'bg-green-100 text-green-800'
                              : 'bg-yellow-100 text-yellow-800'
                          }`}>
                            {inv.status === 'Pending' ? 'Pending' : inv.status}
                          </span>
                        </td>
                        <td className="py-3 px-4 flex items-center space-x-2">
                          {inv.status === 'Pending' ? (
                            <>
                              {inv.email === userEmail && (
                                <button
                                  onClick={() => handleAcceptInvite(inv.token)}
                                  className="text-lg bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700"
                                >
                                  Accept
                                </button>
                              )}
                            {inv.email !== currentUser?.email && (isOwner || isManager) && (
                              <button
                                onClick={() => handleRemoveInvite(inv.email)}
                                className="text-lg bg-gray-200 text-gray-700 px-3 py-1 rounded hover:bg-gray-300"
                              >
                                Remove
                              </button>
                              )}
                            </>
                          ) : (
                            <div className="flex items-center space-x-2">
                              {inv.email !== currentUser?.email && (isOwner || isManager)  && (
                                <>
                              <button
                                onClick={() => handleEditAdult(inv)}
                                className="text-lg px-3 py-1 rounded text-gray-700 border border-gray-300 hover:bg-gray-50"
                              >
                                Edit
                              </button>
                              <button
                                onClick={() => handleRemoveInvite(inv.email, false)}
                                disabled={isRemoving[inv.email]}
                                className="text-lg px-3 py-1 rounded text-red-600 border border-red-200 hover:bg-red-50 disabled:opacity-75"
                              >
                                {isRemoving[inv.email] ? (
                                  <span className="flex items-center gap-2">
                                    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                                    </svg>
                                    Removing...
                                  </span>
                                ) : (
                                  'Remove'
                                )}
                              </button>
                              </>
                              )}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}

                    {/* Received Invitations */}
                    {Array.isArray(receivedInvites) && receivedInvites.filter(inv => inv.status === 'Pending').map(inv => (
                      <tr key={inv._id} className={`border-b ${inv.status === 'Accepted' ? 'bg-green-50' : ''}`}>
                        <td className="py-3 px-4 text-gray-700">{inv.from.inviterId.email}</td>
                        <td className="py-3 px-4">{inv.role === 'manager' ? 'Manager' : 'Member'}</td>
                        <td className="py-3 px-4">
                          {ownedCanvases.find(canvas => canvas._id === inv.canvasId)?.name || 'select'}
                        </td>
                        <td className="py-3 px-4">
                          <span className={`px-2 py-1 rounded-full text-sm ${
                            inv.status === 'Accepted'
                              ? 'bg-green-100 text-green-800'
                              : 'bg-yellow-100 text-yellow-800'
                          }`}>
                            {inv.status}
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          {inv.status === 'Pending' ? (
                            <div className="flex items-center space-x-2">
                              <button
                                onClick={() => handleAcceptInvite(inv.token, inv._id)}
                                disabled={isAccepting[inv._id]}
                                className="add-btn-settings"
                              >
                                {isAccepting[inv._id] ? (
                                  <span className="flex items-center justify-center gap-2">
                                    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                                    </svg>
                                    Accepting...
                                  </span>
                                ) : (
                                  'Accept'
                                )}
                              </button>
                              <button
                                onClick={() => handleRejectInvite(inv.id)}
                                disabled={isRejecting[inv._id]}
                                className="text-sm bg-red-600 text-white px-4 py-1.5 rounded-lg hover:bg-red-700 disabled:opacity-75 min-w-[90px]"
                              >
                                {isRejecting[inv._id] ? (
                                  <span className="flex items-center justify-center gap-2">
                                    <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                                    </svg>
                                    Rejecting...
                                  </span>
                                ) : (
                                  'Reject'
                                )}
                              </button>
                            </div>
                          ) : (
                            <span className="text-sm text-green-600"></span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>


                  
                  

                  
                </table>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-8">
            {/* Kids section */}
            <div>
              <div className="flex justify-between items-center mb-4">
                <h3 className="font-semibold text-[#0a363c]">Kids</h3>
                <button
                  onClick={() => {
                    if (!canAddKids()) {
                      toast.error(getPlanMessage());
                      return;
                    }
                    setShowKidForm(true);
                  }}
                  className={`add-btn-settings ${
                    canAddKids() 
                      ? 'bg-btn-primary text-white hover:opacity-90' 
                      : 'bg-gray-200 text-gray-600 cursor-not-allowed'
                  }`}
                 disabled={!(isManager || isOwner)}
                >
                  Add User
                </button>
              </div>

              {!canAddKids() && (
                <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                  <div className="flex items-center justify-between">
                    <p className="text-sm text-yellow-700">
                      {getPlanMessage()}
                    </p>
                    <button
                      onClick={() => navigate('/user-subscription')}
                      disabled = {!isOwner}
                      className="px-4 py-1.5 bg-btn-primary text-white text-sm rounded-lg hover:opacity-90"
                    >
                      Upgrade Plan
                    </button>
                  </div>
                </div>
              )}

              {showKidForm && (
                <form onSubmit={handleCreateKid} className="mb-4 p-4 bg-gray-50 rounded-lg w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="w-full">
          <input
            type="text"
            placeholder="Kid's name"
            value={kidData.name}
            onChange={e => setKidData({ ...kidData, name: e.target.value })}
            className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent"
            required
          />
        </div>
        <div className="w-full">
          <input
            type="email"
            placeholder="Email"
            value={kidData.email}
            onChange={e => setKidData({ ...kidData, email: e.target.value })}
            className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent"
          />
        </div>
        <div className="w-full">
          <select
            value={kidData.canvasId}
            onChange={e => setKidData({ ...kidData, canvasId: e.target.value })}
            className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent"
            required
          >
            <option value="">Select Canvas</option>
            {Array.isArray(ownedCanvases) && ownedCanvases.map(canvas => (
              <option key={canvas._id} value={canvas._id}>{canvas.name}</option>
            ))}
          </select>
        </div>
        <div className="w-full relative col-span-full md:col-span-2">
          <input
            type={showKidPassword ? 'text' : 'password'}
            placeholder="Password"
            value={kidData.password}
            onChange={e => {
              setKidData({ ...kidData, password: e.target.value });
              validatePassword(e.target.value);
            }}
            className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-btn-primary focus:border-transparent pr-10"
            required
          />
          <button
            type="button"
            onClick={() => setShowKidPassword(!showKidPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
          >
            {showKidPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
      </div>

      {/* Password strength indicator */}
      {kidData.password &&  passwordStrength !== 'Strong' &&  (
        <div className="mt-3 p-3 bg-white rounded-lg border border-gray-200">
          <div className="space-y-2">
            <p className="text-sm font-medium text-gray-700">Password must contain:</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
              <span className={!(/[A-Z]/.test(kidData.password)) ? 'text-red-500' : 'text-green-500'}>
                {!(/[A-Z]/.test(kidData.password)) ? '✗' : '✓'} One Uppercase Letter
              </span>
              <span className="text-gray-400">•</span>
              <span className={!(/\d/.test(kidData.password)) ? 'text-red-500' : 'text-green-500'}>
                {!(/\d/.test(kidData.password)) ? '✗' : '✓'} One Number
              </span>
              <span className="text-gray-400">•</span>
              <span className={!(/[\W_]/.test(kidData.password)) ? 'text-red-500' : 'text-green-500'}>
                {!(/[\W_]/.test(kidData.password)) ? '✗' : '✓'} One Special Character
              </span>
              <span className="text-gray-400">•</span>
              <span className={kidData.password.length < 8 ? 'text-red-500' : 'text-green-500'}>
                {kidData.password.length < 8 ? '✗' : '✓'} Minimum 8+ Characters
              </span>
            </div>
          </div>
        </div>
      )}

      <div className="mt-4 flex flex-col-reverse sm:flex-row justify-end gap-2">
        <button
          type="button"
          onClick={() => setShowKidForm(false)}
          className="w-full sm:w-auto px-4 py-1.5 border rounded-lg text-sm hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isAddingKid || (kidData.password && passwordStrength !== 'Strong')}
          className="w-full sm:w-auto add-btn-settings disabled:opacity-75"
        >
          {isAddingKid ? (
            <span className="flex items-center gap-2">
              <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                <circle 
                  className="opacity-25" 
                  cx="12" 
                  cy="12" 
                  r="10" 
                  stroke="currentColor" 
                  strokeWidth="4"
                />
                <path 
                  className="opacity-75" 
                  fill="currentColor" 
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              Adding...
            </span>
          ) : (
            'Add Kid'
          )}
        </button>
      </div>
    </form>
              )}

              {showEditKidForm && renderEditKidForm()}

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="text-left py-3 px-4">Name</th>
                      <th className="text-left py-3 px-4">Kid Email</th>
                      <th className="text-left py-3 px-4">Shared Canvas</th>
                      <th className="text-left py-3 px-4">Status</th>
                      <th className="text-left py-3 px-4">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="text-sm">
                    {members?.filter(member => member.role === 'kid').map(kid => (
                      <tr key={kid._id} className="border-b">
                        <td className="py-3 px-4 text-gray-700">{kid.name}</td>
                        <td className="py-3 px-4 relative">
                          <div className="flex items-center">
                            <span>
                              {kid.email}
                            </span>
                          </div>
                        </td>
                        <td className="py-3 px-4">
                          {ownedCanvases.find(canvas => canvas._id === kid.canvasId)?.name || 'select'}
                        </td>
                        <td className="py-3 px-4">
                          <span className={`px-2 py-1 rounded-full text-sm ${
                            kid.status === 'Active' 
                              ? 'bg-green-100 text-green-800'
                              : 'bg-yellow-100 text-yellow-800'
                          }`}>
                            {kid.status}
                          </span>
                        </td>
                        <td className="py-3 px-4">
                          <div className="flex items-center space-x-2">
                            <button
                              onClick={() => handleEditKid(kid)}
                              className="text-lg px-3 py-1 rounded text-gray-700 border border-gray-300 hover:bg-gray-50"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => handleRemoveKid(kid.email)}
                              disabled={isRemoving[kid.email]}
                              className="text-lg px-3 py-1 rounded text-red-600 border border-red-200 hover:bg-red-50 disabled:opacity-75"
                            >
                              {isRemoving[kid.email] ? (
                                <span className="flex items-center gap-2">
                                  <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                                  </svg>
                                  Removing...
                                </span>
                              ) : (
                                'Remove'
                              )}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    );
    
  };

  export default ManageGroupContent;
